import { useRef } from "react";
import { Button, Dialog, Flex, VisuallyHidden } from "@radix-ui/themes";
import { Dialog as DialogPrimitive } from "radix-ui";
import AlertComponent from "./AlertComponent";
import { TranslatedText } from "../../../utilities/TranslatedText";
import styles from "./styles/OverlayComponent.module.scss";

interface IOverlayComponentProps {
  alerts: { id: string | number; message: string }[];
  handleDismiss: (data: any) => void;
}

export default function OverlayComponent(props: IOverlayComponentProps) {
  const continueRef = useRef<HTMLButtonElement>(null);

  function dismiss() {
    props.handleDismiss(Object.assign({}, props, { type: "overlay" }));
  }

  return (
    <Dialog.Root open onOpenChange={(open) => !open && dismiss()}>
      <Dialog.Content
        className={styles.overlay}
        maxWidth="640px"
        onInteractOutside={(e) => e.preventDefault()}
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          continueRef.current?.focus();
        }}
      >
        <VisuallyHidden>
          <Dialog.Title>
            <TranslatedText>Announcement</TranslatedText>
          </Dialog.Title>
        </VisuallyHidden>
        <DialogPrimitive.Description asChild>
          <div
            className={styles.message}
            tabIndex={0} // the message is the scroll region, so it has to be focusable
          >
            {props.alerts.map((alert) => (
              <AlertComponent key={alert.id} message={alert.message} />
            ))}
          </div>
        </DialogPrimitive.Description>
        <Flex justify="end" className={styles.footer}>
          <Button size="3" ref={continueRef} onClick={dismiss}>
            <TranslatedText>Continue</TranslatedText>
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
